import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

import { ref } from 'vue'
import { FacilityDto, editCompanyFacility, addCompanyFacility } from '@/api/attendance'
import { getAllEnterpriseList } from '@/api/enterprise'


export default /*@__PURE__*/_defineComponent({
  __name: 'machine-editor',
  props: {
    title: { default: '新增考勤机' }
  },
  emits: ['update-success'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const visible = ref(false) as any
const formRef = ref() as any
const formData = ref({
    name: '',
    serveCompanyId: '',
    snCode: ''
})
const formRule = ref({
    name: [
        { required: true, message: '考勤机名称不能为空', trigger: 'blur' },
        { max: 16, message: '考勤机名称不能超过16位', trigger: 'blur' }
    ],
    serveCompanyId: [
        { required: true, message: '关联企业不能为空', trigger: 'change' }
    ],
    snCode: [
        { required: true, message: '设备SN码不能为空', trigger: 'blur' },
        { pattern: /^ZD\d{7}A$/, message: '设备SN码格式不正确', trigger: 'blur' }
    ]
})

const companyList = ref([])

const getCompanyList = async (serveCompanyName) => {
    const { list } = await getAllEnterpriseList({
        pageNum: 1,
        pageSize: 50,
        serveCompanyName
    })
    companyList.value = list
}

const onOpen = (machine) => {
    if (machine) {
        formData.value = {
            ...machine
        }
    }
    if (machine?.serveCompanyId) {
        companyList.value = [{
            id: machine.serveCompanyId,
            serveCompanyName: machine.serveCompanyName
        }]
    } else {
        getCompanyList('')
    }
    formRef.value?.clearValidate()
    visible.value = true
}

const onBeforeClose = (done?: Function) => {
    companyList.value = []
    formData.value = {
        name: '',
        serveCompanyId: '',
        snCode: ''
    }
    formRef.value?.clearValidate()
    done?.()
}

const onClose = () => {
    onBeforeClose()
    visible.value = false
}
const emit = __emit
const onSubmit = async () => {
    const valid = await new Promise((resolve) => {
        formRef.value.validate((valid: boolean) => {
            resolve(valid)
        })
    })
    if (valid) {
        if (formData.value.id) {
            console.log('编辑操作')
            await editCompanyFacility(formData.value)
            console.log('考勤机信息更新成功')
        } else {
            console.log('新增操作')
            await addCompanyFacility({
                name: formData.value.name,
                snCode: formData.value.snCode,
                serveCompanyId: formData.value.serveCompanyId,
                type: 0
            })
            console.log('考勤机添加成功')
        }
        emit('update-success')
        onClose()
    } else {
        console.error('表单验证失败')
        return false
    }
}

__expose({
    open: onOpen,
    close: onClose
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: _ctx.title,
    width: "500px",
    "before-close": onBeforeClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: onClose }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onSubmit
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        "label-position": "top",
        model: formData.value,
        rules: formRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "考勤机名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                placeholder: "请输入考勤机名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "关联企业",
            prop: "serveCompanyId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.serveCompanyId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.serveCompanyId) = $event)),
                filterable: "",
                remote: "",
                "remote-method": getCompanyList,
                placeholder: "请搜索选择企业",
                class: "w-full",
                disabled: !!formData.value.id
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.serveCompanyName,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN码",
            prop: "snCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.snCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.snCode) = $event)),
                placeholder: "请输入设备SN码",
                disabled: !!formData.value.id
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})